import OEditResource from './o-edit-resource.vue'

export default OEditResource
